// MultiplicationDemo.js
import React from "react";

/**
 * This component demonstrates multiplication
 * by repeated addition (displaying an array of “💙”).
 * 
 * Props:
 *  - multiplicationNum1, multiplicationNum2, multiplicationResult
 *  - setMultiplicationNum1, setMultiplicationNum2
 *  - handleMultiplication
 */
export default function MultiplicationDemo({
  multiplicationNum1,
  multiplicationNum2,
  multiplicationResult,
  setMultiplicationNum1,
  setMultiplicationNum2,
  handleMultiplication,
}) {
  return (
    <div style={{ border: "1px solid #ccc", padding: "10px", marginTop: "15px" }}>
      <h4>Multiplication Demo</h4>
      <p>
        Enter two numbers to multiply, then see the repeated addition array.
      </p>

      <div>
        <label>
          <strong>First Number:</strong>{" "}
          <input
            type="number"
            style={{ width: 50 }}
            value={multiplicationNum1}
            onChange={(e) => setMultiplicationNum1(+e.target.value || 0)}
          />
        </label>
        {"  "}
        <label>
          <strong>Second Number:</strong>{" "}
          <input
            type="number"
            style={{ width: 50 }}
            value={multiplicationNum2}
            onChange={(e) => setMultiplicationNum2(+e.target.value || 0)}
          />
        </label>
      </div>

      <button 
        style={{ marginTop: 10 }}
        onClick={handleMultiplication}
      >
        Multiply
      </button>

      {multiplicationResult && multiplicationResult.length > 0 && (
        <div style={{ marginTop: 10 }}>
          <p>Array Representation:</p>
          {multiplicationResult.map((row, idx) => (
            <div key={idx} style={{ lineHeight: "1.6em" }}>
              {row.join(" ")}
            </div>
          ))}
          <p style={{ marginTop: 5 }}>
            So total is <strong>{multiplicationNum1 * multiplicationNum2}</strong>.
          </p>
        </div>
      )}
    </div>
  );
}
